module.exports = __webpack_public_path__ + "static/media/lock.41a19633.svg";